import {GqlModel, GqlModelListOperator} from "../graphql/graphql.model";
import {jsonProperty} from "../json.model";
import gql from "graphql-tag";

export type BreadcrumbMode = "TEXT" | "HREF" | "ROUTER_LINK" | "ROUTER_LINK_AND_PARAMS";

export class BreadcrumbGqlModel extends GqlModel {
  static mapper: GqlModelListOperator<BreadcrumbGqlModel> = GqlModel.buildListMapper(BreadcrumbGqlModel, "breadcrumbs");

  static fragment: any = gql`
    fragment breadcrumbData on Breadcrumb {
      text
      routerLink
      queryParams
      href
      clickable
    }
  `;

  @jsonProperty("string") text: string;
  @jsonProperty("json") routerLink: any;
  @jsonProperty("json") queryParams: any;
  @jsonProperty("string") href: string;

  mode: BreadcrumbMode = "TEXT";

  constructor(data?: any) {
    super(data);

    if (data) {
      if (data["clickable"]) {
        if (data["href"]) {
          this.mode = "HREF";
        } else if (data.routerLink) {
          if (data.queryParams) {
            this.mode = "ROUTER_LINK_AND_PARAMS";
          } else {
            this.mode = "ROUTER_LINK";
          }
        }
      }
    }
  }
}
